module.exports = __webpack_public_path__ + "static/media/flexline_black_logo_de.52334552.png";